import * as zod from 'zod';

export default zod.object({
  latestResult: zod.string().nullable(),
});
